import { useEffect } from "react";
import { Helmet } from "react-helmet";
import { useHistory } from "react-router";
import Layout from "../../components/Layout";
import LayoutCard from "../../components/LayoutCard";
import { Heading, Text } from "../../components/Type";
import Button from "../../components/Button";
import { ArrowRight } from "../../components/Icons/general-interface-1";
import { useStoreContext } from "../../contexts/StoreProvider";
import styles from "./index.module.scss";

const Home = () => {
  const { state: { user, loading } } = useStoreContext();
  const history = useHistory();

  useEffect(() => {
    if (user) {
      if (user.role.type === "administrator") {
        history.replace("/admin/clients");
      } else {
        history.replace("/dashboard");
      }
    }
  }, [user, history, loading]);

  if (user) return null;
  return (
    <Layout>
      <Helmet>
        <title>Motion Home</title>
      </Helmet>
      <LayoutCard header={<Heading size="h4">Please login</Heading>}>
        <Text>You need to login to access this site.</Text>
        <div className={styles.buttonRow}>
          <Button
            primary
            icon={<ArrowRight />}
            onClick={() => history.push("/login")}
          >
            Log in
          </Button>
        </div>
      </LayoutCard>
    </Layout>
  );
};

export default Home;
